<template>
    <section class="cabinet-content-wrap">
        <HeaderPublic />

        <div class="cabinet-content full product cabinet__product-page">
            <template v-if="product">
                <section class="cabinet__breadcrumbs">
                    <router-link to="/" class="cabinet__breadcrumbs-link">Главная</router-link>
                    <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                    <router-link to="/catalog" class="cabinet__breadcrumbs-link">Каталог</router-link>
                    <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                    <template v-if="product.main_display_category">
                        <template v-if="product.main_display_category.parent">
                            <router-link
                                v-if="product.main_display_category.parent"
                                :to="{
                                    name: 'CategoryID',
                                    params: {
                                        id: product.main_display_category.parent.url
                                    }
                                }"
                                class="cabinet__breadcrumbs-link"
                            >
                                {{ product.main_display_category.parent.name }}
                            </router-link>
                            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                        </template>
                        <router-link
                            :to="{
                                name: 'CategoryID',
                                params: {
                                    id: product.main_display_category.url
                                }
                            }"
                            class="cabinet__breadcrumbs-link"
                        >
                            {{ product.main_display_category.name }}
                        </router-link>
                        <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                    </template>
                    <a v-if="product.brand.subdomain_url" :href="product.brand.subdomain_url" class="cabinet__breadcrumbs-link">{{ product.brand.BrandName }}</a>
                    <router-link
                        v-else
                        :to="{
                            name: 'BrandsID',
                            params: { id: product.BrandID }
                        }"
                        class="cabinet__breadcrumbs-link"
                    >
                        {{ product.brand.BrandName }}
                    </router-link>
                </section>
                <div class="product-card">
                    <section class="cabinet-product-detail d-flex flex-column flex-md-row justify-content-md-between w-100">
                        <div class="cabinet-product-left mb-5 mb-md-0">
                            <image-swiper :images="product.images" />
                        </div>

                        <div class="cabinet-product-right">
                            <a v-if="product.brand.subdomain_url" :href="product.brand.subdomain_url" to="/" class="product-card__brand">
                                <div class="product-card__brand-img">
                                    <img v-if="!product.brand.logo" src="img/no-img.jpg" alt="" />
                                    <img v-else :src="product.brand.logo" alt="" />
                                </div>
                                <div class="product-card__brand-title">
                                    {{ product.brand.BrandName }}
                                </div>
                            </a>
                            <router-link v-else :to="`${isRetailerPatch}/brands/${product.brand.BrandID}`" class="product-card__brand">
                                <div class="product-card__brand-img">
                                    <img v-if="!product.brand.logo" src="img/no-img.jpg" alt="" />
                                    <img v-else :src="product.brand.logo" alt="" />
                                </div>
                                <div class="product-card__brand-title">
                                    {{ product.brand.BrandName }}
                                </div>
                            </router-link>
                            <h1 class="h1 cabinet-title">
                                {{ product.Name || product.type.Name }}
                            </h1>
                            <div class="product-card__label">Артикул: {{ product.Article }}</div>
                            <div class="product-card__info">
                                <div v-if="product.CollectionID" class="product-card__info-item">
                                    <span class="product-card__info-title">Коллекция</span>
                                    <div class="product-card__info-line"></div>
                                    <div class="product-card__info-value">
                                        <router-link
                                            :to="{
                                                name: `${isRetailer ? 'Retailer' : ''}CategoryID`,
                                                params: {
                                                    id: 'all',
                                                    filterBy: {
                                                        collections: product.CollectionID
                                                    }
                                                }
                                            }"
                                            class="cabinet-link"
                                        >
                                            {{ nameCollection(product.CollectionID) }}
                                        </router-link>
                                    </div>
                                </div>
                                <div v-if="product.materials" class="product-card__info-item">
                                    <span class="product-card__info-title">Материал</span>
                                    <div class="product-card__info-line"></div>
                                    <div class="product-card__info-value">
                                        {{ product.materials.map(material => material.Name).join(', ') }}
                                    </div>
                                </div>
                                <div v-if="product.materials.map(el => el.pivot.Fineness).length" class="product-card__info-item">
                                    <span class="product-card__info-title">Проба</span>
                                    <div class="product-card__info-line"></div>
                                    <div class="product-card__info-value">
                                        {{ product.materials.map(material => material.pivot.Fineness).join(', ') || '—' }}
                                    </div>
                                </div>
                                <div v-if="product.Weight" class="product-card__info-item">
                                    <span class="product-card__info-title">Примерный вес</span>
                                    <div class="product-card__info-line"></div>
                                    <div class="product-card__info-value">{{ product.Weight }} г</div>
                                </div>
                            </div>
                            <div class="subtitle1 pt-2">
                                <template v-if="product.price_expired == false">
                                    <div v-if="product.Price > 0">
                                        {{ getFormattedNum(product.Price || 0) }}
                                        ₽{{ priceUnit }}
                                    </div>
                                    <div v-else>
                                        Цена по запросу
                                    </div>
                                </template>
                            </div>
                            <div class="product-card__text" v-if="product.price_expired == false && product.Price > 0">
                                Для покупки изделия отправьте заявку производителю. Производитель свяжется с вами и сообщит вам информацию о наличии, стоимости изделия и условиях доставки.
                            </div>
                            <div class="product-card__text" v-else>
                                Для покупки изделия отправьте заявку производителю. Производитель свяжется с вами и уточнит информацию о наличии, стоимости изделия и условиях доставки.
                            </div>
                            <div class="pt-3 d-flex">
                                <button class="button dark" @click="isShowBuyModal = true">Купить</button>
                                <!-- <button class="button whatsapp"></button>
                                <button class="button favorites active">
                                    <span class="favorites-icon"></span>
                                    1k
                                </button> -->
                            </div>

                            <!-- <div class="mt-4">
                                <cabinet-tabs :tabs="tabs">
                                    <product-specifications slot="0" :product="product" />
                                    <product-inserts slot="1" :prыoduct="product" />
                                    <product-description slot="2" :description="product.Description" />
                                </cabinet-tabs>
                            </div> -->
                        </div>
                    </section>
                    <div class="product-card__about">
                        <h2 class="h2 cabinet-title mb-0">Характеристики и описание</h2>
                        <div class="product-card__info">
                            <div v-if="product.main_display_category" class="product-card__info-item">
                                <div class="product-card__info-title">Категория</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">
                                    <router-link
                                        :to="{
                                            name: `${isRetailer ? 'Retailer' : ''}CategoryID`,
                                            params: { id: product.main_display_category.url }
                                        }"
                                        class="cabinet-link"
                                    >
                                        {{ product.main_display_category.name }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="product-card__info-item">
                                <div class="product-card__info-title">Вид изделия</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">{{ product.type.Name }}</div>
                            </div>
                            <div class="product-card__info-item">
                                <div class="product-card__info-title">Бренд</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">
                                    <a v-if="product.brand.subdomain_url" :href="product.brand.subdomain_url" to="/" class="cabinet-link">
                                        {{ product.brand.BrandName }}
                                    </a>
                                    <router-link v-else :to="`${isRetailerPatch}/brands/${product.brand.BrandID}`" class="cabinet-link">
                                        {{ product.brand.BrandName }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="product-card__info-item">
                                <div class="product-card__info-title">Коллекция</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">
                                    <router-link
                                        :to="{
                                            name: `${isRetailer ? 'Retailer' : ''}CategoryID`,
                                            params: {
                                                id: 'all',
                                                filterBy: { collections: product.CollectionID }
                                            }
                                        }"
                                        class="cabinet-link"
                                    >
                                        {{ nameCollection(product.CollectionID) }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="product-card__info-item">
                                <div class="product-card__info-title">Артикул</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">{{ product.Article }}</div>
                            </div>
                            <div class="product-card__info-item">
                                <div class="product-card__info-title">Материал</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value">{{ product.materials.map(material => material.Name).join(', ') }}</div>
                            </div>
                            <div v-if="product.ItemInsert" class="product-card__info-item">
                                <div class="product-card__info-title">Вставки</div>
                                <div class="product-card__info-line"></div>
                                <div class="product-card__info-value product-card__info-value--large" v-html="product.ItemInsert"></div>
                            </div>
                        </div>

                        <div v-if="product.inserts && product.inserts.length > 0" class="product-card__about-swiper">
                            <div class="swiper swiper-info">
                                <div class="swiper-wrapper">
                                    <div v-for="(insert, i) of product.inserts" :key="insert.ItemInsertID" class="swiper-slide">
                                        <div class="product-card__about-item">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="product-card__about-item-title">{{ nameInsertMaterial(insert.MaterialID) }}</div>
                                                <div class="product-card__about-item-label">Вставка</div>
                                            </div>
                                            <div class="product-card__info">
                                                <div v-if="insert.Quantity" class="product-card__info-item">
                                                    <div class="product-card__info-title">Количество камней</div>
                                                    <div class="product-card__info-line"></div>
                                                    <div class="product-card__info-value">{{ insert.Quantity }}</div>
                                                </div>
                                                <div class="product-card__info-item" v-if="insert.ColorID">
                                                    <div class="product-card__info-title">Цвет вставки</div>
                                                    <div class="product-card__info-line"></div>
                                                    <div class="product-card__info-value">{{ nameInsertColor(insert.ColorID) }}</div>
                                                </div>
                                                <div class="product-card__info-item" v-if="insert.Clarity">
                                                    <div class="product-card__info-title">Чистота вставки</div>
                                                    <div class="product-card__info-line"></div>
                                                    <div class="product-card__info-value">{{ insert.Clarity }}</div>
                                                </div>
                                                <div class="product-card__info-item" v-if="insert.FacetID || insert.FaceNumber">
                                                    <div class="product-card__info-title">Огранка</div>
                                                    <div class="product-card__info-line"></div>
                                                    <div class="product-card__info-value">
                                                        {{ nameInsertFacet(insert.FacetID) }}
                                                        <span v-if="insert.FaceNumber">, граней: {{ insert.FaceNumber }}</span>
                                                    </div>
                                                </div>
                                                <div class="product-card__info-item" v-if="insert.Size">
                                                    <div class="product-card__info-title">Общая каратность</div>
                                                    <div class="product-card__info-line"></div>
                                                    <div class="product-card__info-value">{{ insert.Size }} crt</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-card__about-text">
                            {{ truncatedDescription }}
                            <span v-if="isTruncated">...</span>
                        </div>
                        <div v-if="product.Description && product.Description.length > 445" class="product-card__about-text-more" @click="toggleDescription">{{ buttonText }}</div>
                    </div>
                </div>
                <div v-if="product.sets.length && itemsInSet.length" class="brand-section">
                    <div class="brand-container">
                        <div class="brand-page">
                            <div class="brand-page__title text-left">Изделия в комплекте</div>
                            <div class="brand-page__swiper">
                                <div class="swiper__button swiper__button-prev js-products-prev-1"></div>
                                <div class="swiper__button swiper__button-next js-products-next-1"></div>
                                <div class="swiper swiper-products-1">
                                    <div class="swiper-wrapper">
                                        <div v-for="item in itemsInSet" :key="item.item_id" class="swiper-slide">
                                            <router-link :to="`/catalog/product/${item.item.ItemID}`" class="cabinet__catalog-image">
                                                <img v-if="item.item.images" :src="item.item.images[0].url" />
                                                <img v-else src="img/no-photo.jpg" />
                                            </router-link>

                                            <div class="cabinet__catalog-title d-flex align-items-center mb-auto" v-if="item.item.brand">
                                                <a v-if="item.item.brand.subdomain_url" :href="item.item.brand.subdomain_url" class="cabinet__catalog-title_value">
                                                    {{ item.item.brand.BrandName }}
                                                </a>
                                                <router-link v-else :to="`/brands/${item.item.brand.BrandID}`" class="cabinet__catalog-title_value">
                                                    {{ item.item.brand.BrandName }}
                                                </router-link>
                                            </div>

                                            <div class="cabinet__catalog-category">
                                                {{ item.item.Category_src }}
                                            </div>

                                            <div class="cabinet__catalog-code">
                                                {{ item.item.Article }}
                                            </div>

                                            <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                                                <div v-for="material in item.item.materials" :key="material.MaterialID" class="cabinet__catalog-tag">
                                                    <a href="javascript:void(0)">{{ material.Name }}</a>
                                                </div>
                                            </div>

                                            <div class="cabinet__catalog-info">
                                                <div class="cabinet__catalog-price" v-if="item.price_expired == false && item.price !== 0">{{ item.item.Price }} Р/шт</div>
                                                <div v-if="item.Weight" class="cabinet__catalog-weight">{{ item.item.Weight }} гр</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="brand-section" v-if="product.brand.brand_page">
                    <div class="brand-container">
                        <div class="brand-page__title text-left">Бренд</div>
                        <div class="about">
                            <div class="about__image">
                                <img :src="product.brand.brand_page.banner_desktop" alt="" />
                            </div>
                            <a v-if="product.brand.subdomain_url" :href="product.brand.subdomain_url" to="/" class="about__head">
                                <div class="about__head-img">
                                    <img v-if="!product.brand.logo" src="img/no-img.jpg" alt="" />
                                    <img v-else :src="product.brand.logo" alt="" />
                                </div>
                                <div class="about__head-text">{{ product.brand.BrandName }}</div>
                            </a>
                            <router-link v-else :to="`${isRetailerPatch}/brands/${product.brand.BrandID}`" class="about__head">
                                <div class="about__head-img">
                                    <img v-if="!product.brand.logo" src="img/no-img.jpg" alt="" />
                                    <img v-else :src="product.brand.logo" alt="" />
                                </div>
                                <div class="about__head-text">{{ product.brand.BrandName }}</div>
                            </router-link>
                            <div class="about__text text-left">
                                <p v-html="product.brand.brand_page.description"></p>
                            </div>
                            <div class="brand-page__button text-left">
                                <a v-if="product.brand.subdomain_url" :href="product.brand.subdomain_url" to="/" class="pl-0 btn dark">
                                    Смотреть все изделия бренда
                                </a>
                                <router-link v-else :to="`${isRetailerPatch}/brands/${product.brand.BrandID}`" class="pl-0 btn dark">
                                    Смотреть все изделия бренда
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="product.other_brand_items && product.other_brand_items.length > 0" class="brand-section">
                    <div class="brand-container">
                        <div class="brand-page">
                            <div class="brand-page__title text-left">Другие изделия {{ product.brand.BrandName }}</div>
                            <div class="brand-page__swiper">
                                <div class="swiper__button swiper__button-prev js-products-prev-2"></div>
                                <div class="swiper__button swiper__button-next js-products-next-2"></div>
                                <div class="swiper swiper-products-2">
                                    <div class="swiper-wrapper">
                                        <div v-for="item in product.other_brand_items" :key="item.ID" class="swiper-slide">
                                            <router-link :to="`/catalog/product/${item.ItemID}`" class="cabinet__catalog-image">
                                                <img v-if="item.images" :src="item.images[0].url" />
                                                <img v-else src="img/no-photo.jpg" />
                                            </router-link>

                                            <div class="cabinet__catalog-title d-flex align-items-center mb-auto" v-if="item.brand">
                                                <a v-if="item.brand.subdomain_url" :href="item.item.brand.subdomain_url" class="cabinet__catalog-title_value">
                                                    {{ item.brand.BrandName }}
                                                </a>
                                                <router-link v-else :to="`/brands/${item.brand.BrandID}`" class="cabinet__catalog-title_value">
                                                    {{ item.brand.BrandName }}
                                                </router-link>
                                            </div>

                                            <div class="cabinet__catalog-category">
                                                {{ item.Category_src }}
                                            </div>

                                            <div class="cabinet__catalog-code">
                                                {{ item.Article }}
                                            </div>

                                            <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                                                <div v-for="material in item.materials" :key="material.MaterialID" class="cabinet__catalog-tag">
                                                    <a href="javascript:void(0)">{{ material.Name }}</a>
                                                </div>
                                            </div>

                                            <div class="cabinet__catalog-info">
                                                <div v-if="item.Price > 0 && item.price_expired == false" class="cabinet__catalog-price">{{ item.Price }} Р/шт</div>
                                                <div v-if="item.Weight && item.Weight > 0" class="cabinet__catalog-weight">{{ item.Weight }} гр</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div v-else-if="error">
                <div class="error text-center">
                    <div class="error-image">
                        <img src="/img/icons/error.svg" alt="" />
                    </div>
                    <div class="error-title">
                        Упс! Что-то пошло не так.
                    </div>
                    <div class="error-button">
                        <button type="button" class="cabinet-btn" @click="getProduct">
                            Попробовать еще раз
                        </button>
                    </div>
                </div>
            </div>

            <p v-else>Loading...</p>
        </div>
        <div v-if="isShowBuyModal" class="app-overlay" @click="isShowBuyModal = false"></div>
        <div v-if="isShowBuyModal" class="app-modal">
            <div class="app-modal-order">
                <div class="v2-retailer-cart__customer v2-retailer-cart__customer--public js-customer" v-if="isOrderSuccesed">
                    <header class="cabinet-header flex flex-align-center justify-content-between">
                        <h1 class="h1 v2-retailer-title">Ваш заказ отправлен!</h1>
                    </header>

                    <div class="v2-retailer-cart__placed">
                        <div class="mb-3">
                            Мы отправили поставщику письмо с изделием, которое вы хотите заказать. Также мы указали в письме ваши контактные данные, чтобы поставщик мог с вами связаться.
                        </div>
                    </div>
                </div>
                <div class="v2-retailer-cart__customer v2-retailer-cart__customer--public js-customer" v-if="!isOrderSuccesed">
                    <div class="v2-retailer-cart__info">
                        Введите свои данные и производитель свяжется с вами для оформления заказа.
                    </div>
                    <form>
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label required" for="name">Имя</label>
                            <input id="name" v-model.trim="$v.name.$model" type="text" class="cabinet-form-group__input" :class="{ error: $v.name.$error }" />
                            <p v-if="!$v.name.required && $v.name.$dirty" class="cabinet-form-group__note">
                                Поле обязательно для заполения
                            </p>
                        </div>

                        <div class="cabinet-form-group">
                            <span class="phone">+7</span>
                            <label class="cabinet-form-group__label required" for="phone">Номер телефона</label>
                            <the-mask
                                id="phone"
                                v-model.trim="$v.phone.$model"
                                :mask="'###-###-##-##'"
                                type="text"
                                class="cabinet-form-group__input cabinet-form-group__input--phone"
                                :class="{ error: $v.phone.$error }"
                            />
                            <p v-if="!$v.phone.required && $v.phone.$dirty" class="cabinet-form-group__note">
                                Поле обязательно для заполения
                            </p>
                            <p v-if="!$v.phone.minLength && $v.phone.$dirty" class="cabinet-form-group__note">
                                Введите полный номер телефона
                            </p>
                        </div>

                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label required" for="email">Электронная почта</label>
                            <input id="email" v-model.trim="$v.email.$model" type="text" class="cabinet-form-group__input" :class="{ error: $v.email.$error }" />
                            <p v-if="!$v.email.required && $v.email.$dirty" class="cabinet-form-group__note">
                                Поле обязательно для заполения
                            </p>
                            <p v-if="!$v.email.email && $v.email.$dirty" class="cabinet-form-group__note">
                                Некоректный адресс электронной почты
                            </p>
                        </div>
                        <!-- 
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label">Юридическое лицо</label>
                            [название юр лица]
                        </div> -->
                    </form>
                </div>
                <div class="v2-retailer-cart__total js-sticky-total" data-margin-top="32px" v-if="!isOrderSuccesed">
                    <button type="button" class="cabinet-btn cabinet-btn--big cabinet-btn--input-w" @click="submit" v-if="!isOrderSubmitting">
                        Отправить заказ
                    </button>
                    <button type="button" class="cabinet-btn cabinet-btn--big cabinet-btn--input-w" @click="submit" v-else>
                        Отправляем...
                    </button>
                    <div class="v2-retailer-cart__info mt-4">
                        Нажимая “Отправить заказ” я даю согласие на обработку персональных данных в соответствии с
                        <a href="https://docs.goldnet.market/doku.php?id=privacy_policy" target="_blank">Политикой конфиденциальности</a>
                        и принимаю
                        <a href="https://docs.goldnet.market/doku.php?id=user_agreement" target="_blank">Пользовательское соглашение</a>
                        .
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { TheMask } from 'vue-the-mask'
import vClickOutside from 'v-click-outside'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

import HeaderPublic from '@/components/Public/PublicHeader'
// import CabinetTabs from '@/components/Cabinet/Tabs'
import getNameById from '@/mixins/getNameById'
import checkDemoUser from '@/mixins/checkDemoUser.js'
import onResize from '@/mixins/on-resize.js'
import getFormattedNum from '@/utils/getFormattedNum'
// import ProductSpecifications from '@/components/Cabinet/Product/Specifications'
// import ProductDescription from '@/components/Cabinet/Product/Description'
// import ProductInserts from '@/components/Cabinet/Product/Inserts'
import ImageSwiper from '@/components/Cabinet/Retailer/Product/Detail/DetailSwiper.vue'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'

export default {
    name: 'PublicCatalogProduct',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        // ProductSpecifications: ProductSpecifications,
        // ProductInserts: ProductInserts,
        // ProductDescription: ProductDescription,
        // CabinetTabs,
        TheMask,
        ImageSwiper,
        HeaderPublic,
        AddingAndDeletingToPublicCart
    },
    mixins: [getNameById, checkDemoUser, onResize],
    data() {
        return {
            product: null,
            error: false,
            name: '',
            email: '',
            phone: '',
            routeBack: '/',
            successfulDispatchOfGoods: false,
            isClearCartModalOpened: false,
            isShowBuyModal: false,
            isOrderSuccesed: false,
            isOrderSubmitting: false,
            isExpanded: false,
            maxLength: 445
        }
    },
    computed: {
        ...mapGetters('collections', ['nameCollection']),
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('publicSets', ['itemsInSet']),
        ...mapGetters('user', ['isRetailer']),
        ...mapGetters('insert', ['nameInsertMaterial', 'nameInsertColor', 'nameInsertFacet']),
        ...mapGetters({
            publicCart: 'publicCart'
        }),
        priceUnit() {
            const unit = this.getNameById(this.priceUnitOptions, 'abbr', 'id', this.product.PriceUnit)

            return unit ? `/${unit}` : ''
        },
        isRetailerPatch() {
            return this.isRetailer ? '/account' : ''
        },
        tabs() {
            let tabs = ['Характеристики', 'Вставки']
            if (this.product && this.product.Description) {
                tabs.push('Описание')
            }
            return tabs
        },
        isTruncated() {
            return this.product.Description && this.product.Description.length > this.maxLength && !this.isExpanded
        },
        truncatedDescription() {
            if (!this.product.Description) {
                return ''
            }
            if (this.isExpanded || this.product.Description.length <= this.maxLength) {
                return this.product.Description
            }
            return this.product.Description.substring(0, this.maxLength)
        },
        buttonText() {
            return this.isExpanded ? 'Скрыть' : 'Показать еще'
        }
    },
    created() {
        this.getProduct()
        this.setCartPublicFromLocStor()
        this.getInsertMaterials()
        this.getInsertFacets()
        this.getInsertColors()
        this.getCollections()
        this.getTechnologies()
    },
    methods: {
        ...mapActions(['setCartPublicFromLocStor']),
        ...mapActions('publicSets', ['getItemsInSet']),
        ...mapActions('insert', ['getInsertMaterials', 'getInsertFacets', 'getInsertColors']),
        ...mapActions('collections', ['getCollections']),
        ...mapActions('technologies', ['getTechnologies']),
        // ...mapActions('order', ['getTechnologies']),
        ...mapActions('orders', ['singleOrder']),
        submit() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            } else {
                this.isOrderSubmitting = true
                let payload = {
                    Contacts: {
                        Name: this.name,
                        Email: this.email,
                        Phone: this.phone
                    },
                    ItemId: this.$route.params.id
                }
                this.singleOrder(payload)
                    .then(() => {
                        this.isOrderSuccesed = true
                        this.isOrderSubmitting = false
                    })
                    .catch(error => {
                        this.$notify({
                            title: error.response.data.error,
                            type: 'error'
                        })
                        this.isOrderSubmitting = false
                    })
            }
        },
        getProduct() {
            this.error = false
            this.$axios
                .get(`/public/items/${this.$route.params.id}`)
                .then(async res => {
                    this.product = res.data

                    document.title = `${this.product.Name}  ${this.product.brand.BrandName} — купить в ювелирном интернет-магазине goldnet.market`

                    const descEl = document.querySelector('head meta[name="description"]')
                    descEl.setAttribute('content', `${this.product.Name}  ${this.product.brand.BrandName} — купить в ювелирном интернет-магазине goldnet.market. Большой выбор ювелирных украшений от российских производителей.`)

                    if (this.product.sets.length) {
                        await this.getItemsInSet({
                            setID: this.product.sets[0].set_id
                        })
                    }
                    this.$nextTick(() => {
                        this.swiperSlider = new Swiper('.swiper-products-1', {
                            slidesPerView: 4,
                            spaceBetween: 32,
                            direction: 'horizontal',
                            navigation: {
                                nextEl: '.js-products-next-1',
                                prevEl: '.js-products-prev-1',
                                disabledClass: 'hide'
                            },
                            breakpoints: {
                                1023: {
                                    slidesPerView: 3,
                                    spaceBetween: 24
                                },
                                767: {
                                    slidesPerView: 3.59,
                                    spaceBetween: 16
                                },
                                575: {
                                    slidesPerView: 1.48,
                                    spaceBetween: 16
                                }
                            }
                        })
                        this.swiperSlider = new Swiper('.swiper-products-2', {
                            slidesPerView: 4,
                            spaceBetween: 32,
                            direction: 'horizontal',
                            navigation: {
                                nextEl: '.js-products-next-2',
                                prevEl: '.js-products-prev-2',
                                disabledClass: 'hide'
                            },
                            breakpoints: {
                                1023: {
                                    slidesPerView: 3,
                                    spaceBetween: 24
                                },
                                767: {
                                    slidesPerView: 3.59,
                                    spaceBetween: 16
                                },
                                575: {
                                    slidesPerView: 1.48,
                                    spaceBetween: 16
                                }
                            }
                        })
                    })
                    setTimeout(() => {
                        new Swiper('.swiper-info', {
                            slidesPerView: 2.07,
                            spaceBetween: 16,
                            direction: 'horizontal',
                            loop: false,
                            speed: 600,

                            navigation: {
                                nextEl: '.swiper-button-info-next',
                                prevEl: '.swiper-button-info-prev'
                            },

                            breakpoints: {
                                1219: {
                                    slidesPerView: 2
                                },
                                1049: {
                                    slidesPerView: 1.4
                                },
                                767: {
                                    slidesPerView: 1
                                }
                            }
                        })
                    }, 1000)
                })
                .catch(() => {
                    this.error = true
                })
        },
        toggleDescription() {
            this.isExpanded = !this.isExpanded
        },
        getFormattedNum,
        isInteger(num) {
            return (num ^ 0) === num
        }
    },

    validations: {
        name: {
            required
        },
        email: {
            required,
            email
        },
        phone: {
            required,
            minLength: minLength(10)
        }
    }
}
</script>

<style>
.btn:focus {
    box-shadow: none;
}
.product-card__about-text {
    overflow: hidden;
}
.product-card__about-text-more {
    font-size: 14px;
    color: #5d6075;
    cursor: pointer;
    display: inline-block;
    margin-top: 8px;
}
@media screen and (max-width: 760px) {
    .product-card__info-value--large {
        text-align: right;
        white-space: normal;
    }
}
.product-card__brand {
    display: inline-flex;
}
.product-card__brand:hover {
    text-decoration: none;
}
.about__head {
    display: inline-flex;
}
.about__head:hover {
    text-decoration: none;
}
</style>
